export const SET_STATUS = 'news/SET_STATUS';
export const GET_LIST = 'news/GET_LIST';
export const SET_LIST = 'news/SET_LIST';
export const GET_DETAIL = 'news/GET_DETAIL';
export const SET_DETAIL = 'news/SET_DETAIL';
